<template>
  <div class="customer-container">
    <div class="header-toolbar">
      <h2>Order List</h2>
      <div>
        <el-button type="info" @click="goBack" style="margin-right: 10px"
          >Return</el-button
        >
        <el-button type="danger" @click="logout">Log out</el-button>
      </div>
    </div>

    <!-- 搜索栏（支持PI号、PO号搜索） -->
    <el-form
      :inline="true"
      :model="searchForm"
      class="search-form"
      label-width="80px"
    >
      <el-form-item label="PI ID">
        <el-input
          v-model="searchForm.piNo"
          placeholder="Please enter the PI ID to search"
          style="width: 200px"
        ></el-input>
      </el-form-item>
      <el-form-item label="PO ID">
        <el-input
          v-model="searchForm.poNo"
          placeholder="Please enter the PO ID to search"
          style="width: 200px"
        ></el-input>
      </el-form-item>
      <el-form-item label="Status">
        <el-select
          v-model="searchForm.status"
          placeholder="Please select status"
          style="width: 180px"
          clearable
        >
          <el-option
            v-for="(label, value) in statusMap"
            :key="value"
            :label="label"
            :value="value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getCustomerOrders">query</el-button>
        <el-button @click="resetSearch">reset</el-button>
      </el-form-item>
    </el-form>

    <!-- 订单表格：进度为该PI号下所有货物的总完成率 -->
    <el-table
      :data="orderList"
      border
      style="width: 100%; margin-top: 10px"
      stripe
    >
      <el-table-column
        label="PI ID"
        prop="piNo"
        style="width: 15%"
        align="center"
      ></el-table-column>
      <el-table-column
        label="PO ID"
        prop="poNo"
        style="width: 15%"
        align="center"
      ></el-table-column>
      <el-table-column label="progress" style="width: 15%" align="center">
        <template slot-scope="scope">
          <el-progress
            :percentage="Math.round(scope.row.progress || 0)"
            size="small"
            show-text
          ></el-progress>
        </template>
      </el-table-column>
      <el-table-column
        label="Order Status"
        style="width: 18%"
        align="center"
        :formatter="formatOrderStatus"
      ></el-table-column>
      <el-table-column label="operation" style="width: 15%" align="center">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="goToDetail(scope.row)">
            record
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNum"
      :page-sizes="[5, 10, 20]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 20px; text-align: right"
      :locale="enLocale"
    ></el-pagination>

    <!-- 无订单提示 -->
    <div v-if="orderList.length === 0 && !loading" class="no-order-tip">
      Currently, there is no order data associated with your customer ID～
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import { Message } from "element-ui";
import enLocale from "element-ui/lib/locale/lang/en";

export default {
  name: "CustomerOrderList",
  data() {
    return {
      orderList: [], // 订单列表（含聚合后的进度）
      statusMap: {
        1: "Not selected",
        2: "In production",
        3: "In packing",
        4: "Ready for shipping",
        5: "Completed",
      },
      searchForm: { piNo: "", poNo: "", status: "" },
      pageNum: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      userInfo: JSON.parse(localStorage.getItem("userInfo")) || {},
      enLocale: enLocale,
    };
  },
  mounted() {
    this.getCustomerOrders();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goToDetail(row) {
      this.$router.push({
        path: "/order/detail",
        query: {
          piNo: row.piNo,
          poNo: row.poNo,
        },
      });
    },
    formatOrderStatus(row, column, cellValue) {
      if (row.orderStatusText) return row.orderStatusText;
      if (cellValue === null || cellValue === undefined) return "Not selected";
      return this.statusMap[String(cellValue)] || "Not selected";
    },
    logout() {
      localStorage.removeItem("userInfo");
      this.$router.push("/login");
      Message.success("Logout successful");
    },
    resetSearch() {
      this.searchForm.piNo = "";
      this.searchForm.poNo = "";
      this.searchForm.status = "";
      this.pageNum = 1;
      this.getCustomerOrders();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getCustomerOrders();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getCustomerOrders();
    },
    async getCustomerOrders() {
      this.loading = true;
      try {
        const res = await request.get("/api/order/customer/page", {
          params: {
            piNo: this.searchForm.piNo,
            poNo: this.searchForm.poNo,
            pageNum: this.pageNum,
            pageSize: this.pageSize,
            username: this.userInfo.username,
            status: this.searchForm.status,
          },
        });

        if (res.code === 200) {
          // 对每个订单进行**总进度聚合**：该PI号下所有货物的总完成量 / 总订单量
          this.orderList = (res.records || []).map((order) => {
            return {
              ...order,
            };
          });
          this.total = res.total || 0;
        } else {
          Message.error(res.msg || "Failed to query order");
        }
      } catch (err) {
        console.error("Failed to query order", err);
        Message.error("Network anomaly, please try again");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.customer-container {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}

.header-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.search-form {
  background-color: #fff;
  padding: 15px;
  border-radius: 4px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.05);
}

.el-table th.el-table__cell,
.el-table td.el-table__cell {
  text-align: center !important;
}

.no-order-tip {
  text-align: center;
  padding: 50px;
  color: #666;
  font-size: 16px;
}
</style>